const getFieldName = (
    field: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
) => {
    const formFieldDataAttribute = field.dataset.formFieldName ?? '';
    const newField = {
        ...field,
        name: field.name === 'estimated_annual_gtv' ? 'gtv' : field.name,
    };
    return newField.name ?? formFieldDataAttribute;
};

export { getFieldName };
